import React, { FC } from 'react';
import {
  default as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps
} from '@mui/material/FormControlLabel';
import { BpDesignSystem } from '../../types';

export type FormControlLabelProps = BpDesignSystem.PropsWithChildren<MuiFormControlLabelProps & {}>;

export const FormControlLabel: FC<React.PropsWithChildren<FormControlLabelProps>> = ({ dataTest, ...props }) => (
  <MuiFormControlLabel data-test={dataTest} {...props} />
);
